import { ReplaySubject, tap } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AccessControlsMap } from '@/core/types/security/acl';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AclService {
    public static fullAccessControlToken = '*:*';

    private root = `${environment.dashboardApiURL}/acl`;

    private dataChangeSubject = new ReplaySubject<AccessControlsMap>();
    public dataChange$ = this.dataChangeSubject.asObservable();

    constructor(private http: HttpClient) {}

    private _data: AccessControlsMap = {};

    public get data(): AccessControlsMap {
        return this._data;
    }

    public load() {
        return this.http.get<AccessControlsMap>(this.root).pipe(
            tap((val) => {
                this._data = val;
                this.dataChangeSubject.next(val);
            })
        );
    }

    public validateAcl(acl: string[]): void {
        const missing = acl.filter((v) => this._data[v] == null);
        if (missing.length > 0) {
            throw new Error(`Missing access controls [${missing.join(',')}]`);
        }
    }
}
